jQuery(document).ready(function($){  

  
  /* Parallax Section */
  $('.parallax').each(function(){
    $(this).bind('inview', function (event, visible) {
      if(visible == true) {
        $(this).parallax("50%", 0.3);
      } else {
        $(this).css('background-position','');
      }
    });
  });
  
  
   /* Donut Chart */
  $('.dt-sc-donutchart1').one('inview', function (event, visible){
    if (visible == true) {
      $(".dt-sc-donutchart1").donutchart({'size': 200, 'donutwidth': 2, 'fgColor': '#fe6b35', 'bgColor': '#f5f5f5', 'textsize': 30 });
      $(".dt-sc-donutchart1").donutchart("animate");

      $(".dt-sc-donutchart2").donutchart({'size': 200, 'donutwidth': 2, 'fgColor': '#665de5', 'bgColor': '#f5f5f5', 'textsize': 30 });
      $(".dt-sc-donutchart2").donutchart("animate");

      $(".dt-sc-donutchart3").donutchart({'size': 200, 'donutwidth': 2, 'fgColor': '#36a6a0', 'bgColor': '#f5f5f5', 'textsize': 30 });
      $(".dt-sc-donutchart3").donutchart("animate");

      $(".dt-sc-donutchart4").donutchart({'size': 200, 'donutwidth': 2, 'fgColor': '#f4d30f', 'bgColor': '#f5f5f5', 'textsize': 30 });
      $(".dt-sc-donutchart4").donutchart("animate");
    }
  });
  
  
  
  /* PrettyPhoto For Portfolio */
  if($(".gallery").length) {
    $(".gallery a[data-gal^='prettyPhoto']").prettyPhoto({animation_speed:'normal',theme:'light_square',slideshow:3000, autoplay_slideshow: false,social_tools: false,deeplinking:false});		
  }

 

  
  //Smart Resize Start
  $(window).smartresize(function(){
    /* Blog Template Isotope */
    if( $(".apply-isotope").length ){
      $(".apply-isotope").each(function(){
        $(this).isotope({itemSelector : '.column',transformsEnabled:false,masonry: { gutterWidth: 25} });
      });
    }

    if( $('.portfolio-container').length ){
      var $width = $('.portfolio-container').hasClass("no-space") ? 0 : 0;
      $('.portfolio-container').css({overflow:'hidden'}).isotope({itemSelector : '.column', masonry: { gutterWidth: $width } });
    }
  });//Smart Resize End

  //Window Load Start
  $(window).load(function(){
    /* Blog Template Isotope */
    if( $(".apply-isotope").length ){
      $(".apply-isotope").each(function(){
        $(this).isotope({itemSelector : '.column',transformsEnabled:false,masonry: { gutterWidth: 25} });
      });
    }

    if( $('.portfolio-container').length ){
      var $width = $('.portfolio-container').hasClass("no-space") ? 0 : 0;
      $('.portfolio-container').isotope({
        filter: '*',
        masonry: { gutterWidth: $width },
        animationOptions: { duration: 750, easing: 'linear', queue: false  }
      });
    }

    if($("div.sorting-container").length){
      $("div.sorting-container a").click(function(){
        $("div.sorting-container a").removeClass("active-all");
        var $width = $('.portfolio-container').hasClass("no-space") ? 0 : 0;
        var selector = $(this).attr('data-filter');
        $(this).addClass("active-all");

        $('.portfolio-container').isotope({
          filter: selector,
          masonry: { gutterWidth: $width },
          animationOptions: { duration: 750, easing: 'linear', queue: false  }
        });
        return false;
      });
    }
   
  });//Window Load End

});

(jQuery);